import { render, staticRenderFns } from "./ConfirmPurchaseProfileLink.vue?vue&type=template&id=72e91e14&"
import script from "./ConfirmPurchaseProfileLink.vue?vue&type=script&lang=ts&"
export * from "./ConfirmPurchaseProfileLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports